export default __webpack_public_path__ + "static/media/mettmann_dark.3d30c6f0.png";